import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from 'react-intl';
import './ai-header-button.css';

const AI_ICON_PATH = 'M12 2c.4 3.9 1.7 6.3 3.6 7.4 1 .6 2.3 1.1 4.4 1.6' +
  '-2.1.5-3.4 1-4.4 1.6C13.7 13.7 12.4 16.1 12 20c-.4-3.9-1.7-6.3-3.6-7.4' +
  'C7.4 12 6.1 11.5 4 11c2.1-.5 3.4-1 4.4-1.6C10.3 8.3 11.6 5.9 12 2z';

const AiHeaderButton = ({onClick}) => {
  const intl = useIntl();
  return <button
    className='ai-header-button'
    type='button'
    onClick={onClick}
    aria-label={intl.formatMessage({id: 'ai.ask'})}
  >
    <span className='ai-header-button__inner'>
      <span className='ai-header-button__label'><FormattedMessage id='ai.ask'/></span>
      <svg width='19' height='19' viewBox='0 0 24 24' aria-hidden='true'>
        <path d={AI_ICON_PATH} fill='currentColor'/>
      </svg>
    </span>
  </button>;
};

AiHeaderButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default AiHeaderButton;